const initialState = 1;

const healthChecksPaginationReducer = (state = initialState, action) => {
      switch (action.type) {
            case 'SET_SELECTED_HEALTH_CHECKS_PAGE':
                  return action.pageNumber;
            case 'LOGOUT_USER':
                  return 1;
            default:
                  break;
      }
      return state;
};
export default healthChecksPaginationReducer;